/* eslint-disable comma-dangle */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:13:17
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2022-12-09 21:51:15
 */

import mould from './mould'

const guard = {

  /**
   * 需要
   */
  need: [
    mould.order.name,
  ],

  /**
   * 不需要
   */
  unwante: [
    mould.notFind.name,
    mould.index.name,
    mould.about.name,
    mould.services.name,
    mould.serviceslist.name,
    mould.servicescontent.name,
    mould.news.name,
    mould.newscontent.name,
    mould.training.name,
    mould.traininglist.name,
    mould.trainingcontent.name,
    mould.literature.name,
    mould.literaturecontent.name,
    mould.Partners.name,
    mould.database.name,
  ],
  /**
   * 公共
   */
  public: [
    mould.ordercontent.name,
    mould.contrast.name,
    mould.urliterature.name,
    mould.userinfo.name,
    mould.record.name,
    mould.recordcon.name
  ]

}

export default guard



// WEBPACK FOOTER //
// ./src/router/guard.js